function SpareParts() {
  return <div>SpareParts</div>;
}

export default SpareParts;
